import { TopDestinations } from './TopDestinations';

export default TopDestinations;
